const passwordInput = document.querySelector(
  '.enter-password-wrapper input[type="password"]'
);
if (passwordInput) {
  passwordInput.addEventListener("keyup", function (e) {
    if (e.key === "Enter" || e.keyCode === 13) {
      const form = document.querySelector(".enter-password-wrapper form");
      if (form) form.submit();
    }
  });
}

const openNewsletterBtn = document.querySelector("#open-newsletter-modal");
if (openNewsletterBtn) {
  openNewsletterBtn.addEventListener("click", function (e) {
    e.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", "Xa9CDr"]);
  });
}

const closeNewsletterBtn = document.querySelector("#close-newsletter-modal");
if (closeNewsletterBtn) {
  closeNewsletterBtn.addEventListener("click", function (e) {
    e.preventDefault();
    const modal = document.querySelector(".password-content .newsletter-modal");
    if (modal) modal.classList.remove("active");
  });
}
